import { FC, ReactNode } from "react";
import { useFormik } from "formik";
import * as Yup from "yup";
import { FormContainer } from "~/OnboardingApp/components";
import { useNav } from "~/OnboardingApp/features/Nav";
import { useOnboarding } from "~/OnboardingApp/hooks/useOnboarding";
import { useSubmitOnboardingQuestion } from "~/OnboardingApp/hooks/useSubmitOnboardingQuestion";
import { requiredString } from "~/utils/validations";

type Values = {
  firstName: string;
  lastName: string;
};

const validationSchema = Yup.object({
  firstName: requiredString,
  lastName: requiredString,
});

interface Props {
  children: ReactNode;
}

export const NameFormContainer: FC<Props> = ({ children }) => {
  const { goToNext } = useNav();
  const { handleSetOnboarding, firstName, lastName, email } = useOnboarding();
  const { onSubmit: onAuthSubmit } = useSubmitOnboardingQuestion();
  const isAuthenticated = !!email;

  const initialValues: Values = {
    firstName: firstName || "",
    lastName: lastName || "",
  };

  const handleNoAuthSubmit = () => {
    localStorage.setItem("firstName", formik.values.firstName || "");
    localStorage.setItem("lastName", formik.values.lastName || "");
    handleSetOnboarding(formik.values);

    goToNext();
  };

  const handleSubmit = () => {
    if (isAuthenticated) {
      return onAuthSubmit;
    } else {
      return handleNoAuthSubmit;
    }
  };

  const formik = useFormik({
    initialValues,
    onSubmit: handleSubmit(),
    validationSchema,
    validateOnMount: true,
  });

  return <FormContainer formik={formik}>{children}</FormContainer>;
};
